import { useMemo } from 'react';
import { Item } from 'react-photoswipe-gallery';
import styled from 'styled-components';
import { PreviewItem } from 'components/GalleryMediaPreviewer/shared/styles';
import Image from 'components/generic/Image';
import GetScalingAttr from 'helpers/imageScalingHelper';
import { sizes } from 'variables';
import type { ImageMediaItem } from '../../shared/types';

const StyledImg = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
`;

const StyledPreviewItem = styled(PreviewItem)`
    aspect-ratio: 1;
`;

export default function PreviewGalleryImageItem({ imageItem, ...restProps }: { imageItem: ImageMediaItem }) {
    const { original, alt } = imageItem;
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    const { src: srcBigImage, srcSet: srcSetBigImage } = useMemo(
        () =>
            GetScalingAttr({
                src: original,
                sizes: 1780,
                transformType: 'WidthScale',
                imageType: 'product'
            }),
        []
    );

    return (
        <Item width={1780} height={1780} original={srcBigImage} originalSrcset={srcSetBigImage}>
            {({ ref, open }) => (
                <StyledPreviewItem ref={ref} onClick={open} {...restProps}>
                    <StyledImg
                        transformType="WidthScale"
                        imageType="product"
                        sizes={[[sizes.md, 650], 240]}
                        src={original}
                        alt={alt || ''}
                        loading="lazy"
                    />
                </StyledPreviewItem>
            )}
        </Item>
    );
}
